import { Divider } from "@/components/ui/Divider";
import { capitalizeFirst } from "@/helpers/string";
import { AdminAreaSettings } from "@/types/spatial";

import { Button } from "equator-design-system";

import LabelValueItem from "./labelValueItem";

interface AreaSummaryCardProps {
  countryLabel?: string;
  isTreeEnabled: boolean;
  selectedAreaCount?: number;
  adminAreaSettings: AdminAreaSettings | null;
  header?: React.ReactNode;
  emptyState?: React.ReactNode;
  onClear?: () => void;
  disabledClear?: boolean;
}

export const AreaSummaryCard = ({
  countryLabel,
  isTreeEnabled,
  selectedAreaCount = 0,
  adminAreaSettings,
  header,
  emptyState,
  onClear,
  disabledClear
}: AreaSummaryCardProps) => {
  return (
    <div className="bg-white-smoke rounded-lg">
      {header}
      {countryLabel ? (
        // Country
        <div className="p-4 rounded-[12px] flex flex-col bg-white-smoke gap-2">
          <div className="flex flex-col gap-1 max-h-[8.5rem] overflow-y-auto">
            <div className="flex items-center justify-between">
              <span>Country</span>
              {onClear && (
                <Button
                  variant="ghost"
                  onClick={onClear}
                  className="text-primary-teal p-0 h-auto font-semibold disabled:text-light-gray"
                  disabled={disabledClear}
                >
                  Clear
                </Button>
              )}
            </div>
            <span className="text-txtHeading font-medium">{countryLabel}</span>
          </div>

          <Divider className="bg-gainsboro w-full h-[1px]" />

          {/* Area */}
          {isTreeEnabled ? (
            <LabelValueItem label="Area Selected">
              <span className="text-txtHeading font-semibold">
                {selectedAreaCount} Selected
              </span>
            </LabelValueItem>
          ) : (
            Object.entries(adminAreaSettings || {})
              .filter(([level, v]) => v && level !== "lv0") // only show children of country
              .map(([key, value]) => (
                <LabelValueItem
                  key={key}
                  label={capitalizeFirst(value.adm_unit)}
                  value={value.label}
                />
              ))
          )}
        </div>
      ) : (
        emptyState
      )}
    </div>
  );
};
